import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BitSwalService, BitService } from 'ngx-bit';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { asyncValidator } from 'ngx-bit/operates';
import { map, switchMap } from 'rxjs/operators';
import { PermissionService } from '../permission.service';
import * as packer from './language';

@Component({
  selector: 'van-permission-add',
  templateUrl: './permission-add.component.html'
})
export class PermissionAddComponent implements OnInit {
  form: FormGroup;

  constructor(
    public bit: BitService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private swal: BitSwalService,
    private permissionService: PermissionService
  ) {
  }

  ngOnInit(): void {
    this.bit.registerLocales(packer);
    this.form = this.fb.group({
      name: this.fb.group(
        this.bit.i18nGroup({
          validate: {
            zh_cn: [Validators.required],
            en_us: [Validators.required]
          }
        })
      ),
      key: [null, [Validators.required], [this.existsKey]],
      note: [null],
      status: [true, [Validators.required]]
    });
  }

  existsKey = (control: AbstractControl) => {
    return asyncValidator(this.permissionService.validedKey(control.value));
  };

  /**
   * 提交
   */
  submit(data): void {
    this.permissionService.add(data).pipe(
      switchMap(res =>
        this.swal.addAlert(res, this.form, {
          status: true
        })
      )
    ).subscribe(() => {
    });
  }
}
